import { MANTY_COLORS } from 'business/constants';
import { MantyStatus } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';

export const AGENT_ARRIVAL_HYPOTHESIS_ID = 'id';
export const NEW_AGENT = 'Nouvel agent';
export const AGENT_ARRIVAL_HYPOTHESIS = 'agentArrivalHypothesis';

export enum AgentArrivalHypothesisType {
    SIMPLE_ARRIVAL = 'simple_arrival',
}

export const AgentArrivalHypothesisTypesColor = {
    [AgentArrivalHypothesisType.SIMPLE_ARRIVAL]: MANTY_COLORS.cyan,
};
export const SPECIAL_RATE = 0.5533;
export const GENERAL_RATE = 0.4152;
export const FilteredMantyStatus = Object.values(MantyStatus).filter(
    (item) =>
        ![
            MantyStatus.CONTRACTOR,
            MantyStatus.ELECTED_OFFICIAL,
            MantyStatus.TITULAIRE,
            MantyStatus.FONCTIONNAIRE_STAGIAIRE,
            MantyStatus.WAITING_FOR_TITULAIRE_CONTRACTOR,
            MantyStatus.OTHER,
        ].includes(item),
);
